module.exports = __webpack_public_path__ + "img/dab_crudo.124a8f91.jpg";